import React from 'react';

const ValidationError = ({errors, name}) => {

    if (!errors) {
        return <></>;
    }

    return (
        <>
            {errors[name]?.map((message, key) => {
                return (
                    <small key={key} className="text-danger">
                        {message}
                    </small>
                )
            })}
        </>
    );
};

export default ValidationError;
